// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch-button {
  position: relative;
  display: inline-flex;
  align-items: stretch;
  background: #f1e2d7;
  border: 1px solid #D8C4B6;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
}
.switch-button:hover {
  background: #D8C4B6;
  border: 1px solid #213555;
}
.switch-button__highlight {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  border-radius: 10px;
  background: #fff9f2;
  transition: transform 0.3s ease;
  z-index: 0;
}
@media (max-width: 720px) {
  .switch-button__highlight {
    display: none;
  }
}
.switch-button__option {
  flex: 1;
  display: flex;
  min-height: 100%;
  justify-content: center;
  align-items: center;
  vertical-align: center;
  padding: 2px;
  background: transparent;
  border: none;
  position: relative;
  z-index: 1;
}
@media (max-width: 720px) {
  .switch-button__option {
    padding: 4px;
    min-width: 100px;
    background: #fff9f2;
    font-size: 12px;
  }
  .switch-button__option--not-selected-mobile {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AppSwitchButton/AppSwitchButton.scss","webpack://./src/utils/_themeConstants.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,oBAAA;EACA,oBAAA;EAEA,mBCDa;EDEb,yBAAA;EACA,mBAAA;EAEA,gBAAA;EACA,eAAA;AAHF;AAKE;EACE,mBCZW;EDaX,yBAAA;AAHJ;AAME;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,mBCjBc;EDkBd,+BAAA;EACA,UAAA;AAJJ;AAMI;EAXF;IAYI,aAAA;EAHJ;AACF;AAME;EACE,OAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EAEA,uBAAA;EACA,YAAA;EAEA,kBAAA;EACA,UAAA;AANJ;AAQI;EAfF;IAgBM,YAAA;IACA,gBAAA;IACA,mBC5CU;ID6CV,eAAA;EALN;EAOM;IACE,aAAA;EALR;AACF","sourcesContent":["@use \"../../utils/themeConstants\";\r\n\r\n.switch-button {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: stretch;\r\n\r\n  background: themeConstants.$color-light1;\r\n  border: 1px solid themeConstants.$color-medium;\r\n  border-radius: 10px;\r\n\r\n  overflow: hidden;\r\n  cursor: pointer;\r\n\r\n  &:hover {\r\n    background: themeConstants.$color-medium;\r\n    border: 1px solid themeConstants.$color-dark;\r\n  }\r\n\r\n  &__highlight {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 50%;\r\n    height: 100%;\r\n    border-radius: 10px;\r\n    background: themeConstants.$color-brightest;\r\n    transition: transform 0.3s ease;\r\n    z-index: 0;\r\n\r\n    @media(max-width: themeConstants.$mobile-cutoff-width) {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  &__option {\r\n    flex: 1;\r\n    display: flex;\r\n    min-height: 100%;\r\n    justify-content: center;\r\n    align-items: center;\r\n    vertical-align: center;\r\n    padding: 2px;\r\n    \r\n    background: transparent;\r\n    border: none;\r\n    \r\n    position: relative;\r\n    z-index: 1;\r\n\r\n    @media(max-width: themeConstants.$mobile-cutoff-width) {\r\n        padding: 4px;\r\n        min-width: 100px;\r\n        background: themeConstants.$color-brightest;\r\n        font-size: 12px;\r\n\r\n        &--not-selected-mobile {\r\n          display: none;\r\n        }\r\n      }\r\n  }\r\n}\r\n","$color-dark: #213555;\r\n$color-dark-highlight: #3E5879;\r\n\r\n$color-medium: #D8C4B6;\r\n\r\n$color-light: #ebd9cd;\r\n$color-light1: #f1e2d7;\r\n\r\n$color-bright: #F5EFE7;\r\n$color-brightest: #fff9f2;\r\n\r\n$mobile-cutoff-width: 720px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
